import { Component, OnInit, Input } from '@angular/core';
import { BilanEcoLine } from 'src/app/models/api_models/user';
import { BookResult } from 'src/app/models/api_models/book';
import { BookService } from 'src/app/api/book.service';

@Component({
  selector: 'app-book-eco-bilan',
  templateUrl: './book-eco-bilan.component.html',
  styleUrls: ['./book-eco-bilan.component.scss']
})
export class BookEcoBilanComponent implements OnInit {

  private _book : BookResult = null;
  get book() : BookResult {
    return this._book;
  }

  @Input()
  set book(book : BookResult) {
    this._book = book;

    
    if (this._book !== null) {
      this.getBookBilan();
    }
  }

  private _bilan : BilanEcoLine = null
  get bilan() : BilanEcoLine { return this._bilan};
  set bilan(bilan : BilanEcoLine) {this._bilan = bilan;}

  constructor(private bookService : BookService) { }

  private getBookBilan() {
    let start = new Date(this._book.startdate);
    let end = new Date(this._book.enddate);
    start.setTime(start.getTime() - 1000 * 60 * 60 * 2);
    end.setTime(end.getTime() - 1000 * 60 * 60 * 2);
    if (this._book.status == "completed") {
      this.bookService.getBookBilanEco(this._book).subscribe(
        response => {
          // console.log(response);
          if (response !== null && response.list.length > 0) {

            for (const item of response.list) {
              if (item.booking_id == this._book.id) {
                this._bilan = item;
                break;
              }
            }
          }
          else {
            this._bilan = new BilanEcoLine(this._book.startdate, this._book.enddate, 0, 0, this._book.id , 0);
          }
        }
      );
    }

  }

  ngOnInit() {
    
  }

}
